// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_FuKbiB","loginText":"_3GyAFl_a"};